module.exports = __webpack_public_path__ + "static/media/Rectangle 95.fb6bca50.png";